import personDataService = require("../core/persons.dataservice");

export function initialize(module: ng.IModule) {
    module.controller("PersonsNewController", PersonsNewController);

    PersonsNewController.$inject = ["$log", "personDataService", "serviceConfig", "$rootScope", "$state", "$mdDialog"];
}

function PersonsNewController(
    $log: ng.ILogService,
    personDataService: personDataService.IPersonDataService,
    serviceConfig,
    $rootScope: ng.IRootScopeService,
    $state: ng.ui.IStateService,
    $mdDialog: ng.material.IDialogService) {
    
    var vm = this;

    vm.person = { Active: true };
    vm.save = save;
    vm.cancelChanges = cancelChanges;
    vm.webApiUrl = serviceConfig.webApiUrl;

    vm.selectPersonImage = selectPersonImage;
    vm.deletePersonImage = deletePersonImage;
    vm.addPersonImage = addPersonImage;

    vm.imageFile = <File> null;
    vm.imageSource = vm.webApiUrl + "PersonService/" + (vm.person.Id == null ? -1 : vm.person.Id) + "/PersonImage?ImageRv=" + encodeURIComponent(vm.person.ImageFileRv);
    vm.deleteImage = false;

    vm.directiveapi = {};

    activate();

    function activate() {
        $log.info("Persons New Controller up and running...");
    }

    function save() {
        personDataService
            .create(vm.person)
            .then((res) => {
                $log.info("Successfully saved person");
                vm.person = res.entities[0];
                if (vm.imageFile) {
                    personDataService
                        .savePersonImage(vm.imageFile, vm.person.Id)
                        .then(() => {
                        $log.info("Successfully saved person image");
                        goToPersonsPage();
                    })
                        .catch(err => $log.error("Could not save Person image, error occured: " + err));
                }
                else if (vm.deleteImage) {
                    personDataService
                        .deletePersonImage(vm.person.Id)
                        .then(() => {
                        $log.info("Successfully deleted person image");
                        goToPersonsPage();
                        })
                        .catch(err => $log.error("Could not delete Person image, error occured: " + err));
                }
                else {
                    goToPersonsPage();
                }
            })
            .catch(err => $log.error("Could not save Person, error occured: " + err));
    }

    function showAlert(title: string, content: string) : ng.IPromise<any> {
        var confirm = $mdDialog.alert()
            .title(title)
            .textContent(content)
            .ok('Ok');
        
        return $mdDialog.show(confirm)
    }

    function cancelChanges() {
        goToPersonsPage();
    }

    function goToPersonsPage() {
        $state.go("app.resources.persons");
    }

    function selectPersonImage(file: File) {
        if (file.size > 2 * 1024 * 1024) { // 2 mb
            showAlert("File to big", "Maximum allowed file size is 2mb.");
            return;
        };
        vm.deleteImage = false;
        vm.imageFile = file;
        var reader = new FileReader();
        reader.onload = (ev) => {
            if (!vm.deleteImage) {
                vm.imageSource = (<any>ev.target).result;
            }
            $rootScope.$apply();
        };
         //= (function (aImg) { return function (e) { aImg.src = e.target.result; }; })(img);
        reader.readAsDataURL(file);
        
        //file.
        //var tst = 123;
    };

    function deletePersonImage() {
        vm.deleteImage = true;
        vm.imageFile = null;
        vm.imageSource = "#";
        //$rootScope.$apply();
    };

    function addPersonImage() {
        //angular.element($element)
        vm.directiveapi.click();
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons.new.controller.ts